// Desenho do Brasa, o vaga-lume do SiteUP CRM (folha de personagem aprovada
// em 23/08/2026). Um lugar só para o traço: o BrasaMascot (tour, lanterna) e o
// BrasaCompanion (tela de entrada) desenham o mesmo bicho, cada um com a sua
// forma de animar. Viewbox 120 x 120.
export const BRASA_SHAPE = {
  // Asa esquerda: forma ciano da seta do logo, amolecida em folha.
  wingL: {
    d: 'M60 56 C36 46 21 30 27 17 C42 13 57 31 63 52 Z',
    fill: '#3FD2F5',
    opacity: 0.86,
    pivot: [60, 56],
  },
  // Asa direita: forma violeta da seta.
  wingR: {
    d: 'M63 55 C79 39 97 33 105 42 C101 59 83 69 66 66 Z',
    fill: '#7B5CFF',
    opacity: 0.82,
    pivot: [63, 55],
  },
  // Corpo: gota inclinada, azul da marca, com o brilho por cima.
  body: {
    d: 'M59 42 C74 53 76 74 65 88 C58 97 49 97 44 89 C34 75 42 52 59 42 Z',
    fill: '#2781F6',
  },
  shine: {
    d: 'M59 42 C66 50 68 62 65 72 C58 74 49 68 47 58 C50 50 54 45 59 42 Z',
    fill: '#5AA4FF',
    opacity: 0.5,
  },
  // Luz do abdomen: halo difuso e núcleo, no mesmo centro.
  light: { cx: 56, cy: 84, halo: 13, core: 6.5, fill: '#9CF3FF' },
  eyes: [
    { cx: 53, cy: 59 },
    { cx: 63.5, cy: 62 },
  ],
  eyeR: 2.7,
  eyeFill: '#08111F',
  // Centro do corpo: eixo das inclinações.
  pivot: [58, 70],
};
